<template>
    <router-link
        class='productthumb'
        :class='{
            "productthumb--has-hover-img": media.length > 1
        }'
        :to='{ name: "product", params: { slug: handle }}'>

        <div class='productthumb__thumb'>
            <div v-if='media.length > 0' class='productthumb__thumb__default'>
                <Media :media='media[0]' :isFullbleed='true' :alt="media[0]?.alt || title" />
            </div>
            <div v-if='media.length > 1' class='productthumb__thumb__hover'>
                <Media :media='media[1]' :isFullbleed='true' :alt="media[1]?.alt || `Second image for ${title}`" />
            </div>
        </div>
        <div class='productthumb__info'>
            <div class='productthumb__info__title'>
                <span v-for='(word, j) in productTitleArray(title)' :key='`word-${j}`' v-text='word + "&#32;"' />
            </div>
            <div class='productthumb__info__price'>
                <template v-if='statusText'>
                    <span class='productthumb__info__price__soldout' v-text='statusText' />
                </template>
                <template v-else-if='price === 0'>
                    <span class='productthumb__info__price__free' v-text='"Free"' />
                </template>
                <template v-else>
                    <span class='productthumb__info__price__sign' v-text='"$"' />
                    <span class='productthumb__info__price__dollars' v-text='getPriceDollars(price)' />
                    <span class='productthumb__info__price__dot' v-text='"."' />
                    <span class='productthumb__info__price__cents' v-text='getPriceCents(price)' />
                </template>
            </div>
        </div>
    </router-link>
</template>

<script>
import { productTitleArray } from '^/utils/typography'
import { getCardStatusText } from '^/utils/product'
import Media from '^/components/elements/Media.vue'

export default {
    name: 'ProductThumb',
    props: {
        handle: {
            type: String,
            required: true
        },
        media: {
            type: Array,
            required: true,
            default: () => []
        },
        title: {
            type: String,
            required: true
        },
        available: {
            type: Boolean,
            default: true
        },
        price: {
            type: Number,
            required: true
        },
        id: {
            type: [String, Number],
            required: true
        },
        isNotShowAsSoldOut: {
            type: Boolean,
            default: false
        },
        cta: {
            type: Object,
            default: null
        }
    },
    computed: {
        statusText () {
            return getCardStatusText({
                available: this.available,
                isNotShowAsSoldOut: this.isNotShowAsSoldOut,
                cta: this.cta
            })
        }
    },
    methods: {
        getPriceDollars (price) {
            return Math.floor(price / 100)
        },
        getPriceCents (price) {
            return price % 100 || '00'
        },
        productTitleArray: productTitleArray
    },
    components: {
        Media
    }
}
</script>

